module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/january-24fa36dc7cc45566c908c2ddab23f6ba.png";